module.exports = __webpack_public_path__ + "img/minus_white.b3590d63.svg";